import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { LDFeatureFlags, LaunchDarklyFlagManagerService } from '@frontend/sports/launch-darkly/feature';
import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';
import { isNil } from 'lodash-es';

@Injectable()
export default class BetslipDisplayModeService {
    private _betslipDisplayMode: BetslipDisplayMode;
    private readonly ldBetslipModeFlag = LDFeatureFlags.DisplayMode;

    constructor(
        private betslipConfig: BetslipConfig,
        private ldFlagManagerService: LaunchDarklyFlagManagerService,
    ) {
        this.setBetslipDisplayMode();
    }

    get betslipDisplayMode() {
        return this._betslipDisplayMode;
    }

    private setBetslipDisplayMode() {
        const ldDisplayMode = this.toBetslipDisplayMode(this.ldFlagManagerService.getFeatureFlag(this.ldBetslipModeFlag));
        if (this.betslipConfig.displayMode === BetslipDisplayMode.Linear || isNil(ldDisplayMode)) {
            this._betslipDisplayMode = this.betslipConfig.displayMode;

            return;
        }
        this._betslipDisplayMode = ldDisplayMode as BetslipDisplayMode;
    }

    private toBetslipDisplayMode(value: string | boolean | undefined): BetslipDisplayMode | undefined {
        const v = value as unknown as BetslipDisplayMode;
        const displayModes = [BetslipDisplayMode.Linear, BetslipDisplayMode.Tabbed];

        return Object.values(displayModes).includes(v) ? v : undefined;
    }
}
